import axios from "axios";
import { toast } from "react-toastify";
import { NEVER_OWNED_APIS } from "../Config/apiConfig";

export const saveNeverOwnedDetailsAction = async (payload) => {
  try {
    const response = await axios.post(
      NEVER_OWNED_APIS.SAVE_FORM_DATA,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );

    const data = response.data || {};

    // Server can return HTTP 200 with success:false — check the flag
    if (data.success === true) {
      toast.success(data.message || "Details saved successfully.");
      return { success: true, data };
    }

    const errMsg = data.message || "Failed to save details. Please try again.";

    toast.error(errMsg);
    return { success: false, data, error: errMsg };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Something went wrong. Please try again.";

    toast.error(errMsg);
    return {
      success: false,
      data: error.response?.data || null,
      error: errMsg,
    };
  }
};
